import { render } from "./CardSpecHouse.vue?vue&type=template&id=5ccb579c"
import script from "./CardSpecHouse.vue?vue&type=script&lang=js"
export * from "./CardSpecHouse.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/v2/CardSpecHouse.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5ccb579c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5ccb579c', __exports__)) {
    api.reload('5ccb579c', __exports__)
  }
  
  module.hot.accept("./CardSpecHouse.vue?vue&type=template&id=5ccb579c", () => {
    api.rerender('5ccb579c', render)
  })

}


export default __exports__